import styled from '@emotion/styled';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

interface StyledFixedButtonWrapperProps {
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  zIndex?: number;
  bottom?: number | string;
  left?: number | string;
  backgroundColor?: string;
}

export const StyledFixedButtonWrapper = styled.div<StyledFixedButtonWrapperProps>`
  position: fixed;
  left: ${({ left = 0 }) => (typeof left === 'number' ? `${left}px` : left)};
  right: 0;
  bottom: ${({ bottom = '80px' }) =>
    typeof bottom === 'number' ? `${bottom}px` : bottom};
  display: flex;
  justify-content: ${({ justify = 'center' }) => justify};
  align-items: center;
  gap: var(--rk-spacing-sm);
  padding: var(--rk-spacing-lg) var(--rk-spacing-xl);
  z-index: ${({ zIndex = 10 }) => zIndex};
  box-sizing: border-box;
  background-color: ${({
    backgroundColor = 'var(--md-sys-color-surface-container-low)',
  }) => backgroundColor};
  border: none;
  box-shadow: none;

  ${mq(BreakpointSizes.desktop)} {
    padding: var(--rk-spacing-xl);
    bottom: 0;
  }

  & > button {
    max-width: 370px;
    margin-bottom: 0;
  }
`;
